@if (documentTypesWidgetData && initialized) {
    <mvs-widget [widgetData]="documentTypesWidgetData">
    </mvs-widget>
}
